import { Tracker } from 'meteor/tracker';

export const DUREE_AUTO_MASQUAGE_MESSAGE_SUCCES_MS = 5000;

function message_est_succes (pMessage)
  {
    if (!pMessage || typeof pMessage !== 'object') return false;
    const tType = typeof pMessage.type === 'string'
      ? pMessage.type.trim ().toLowerCase ()
      : '';
    return tType === 'succes' || tType === 'success';
  }

export function auto_hide_success_message_reactive (
  pReactiveVar,
  pDelayMs = DUREE_AUTO_MASQUAGE_MESSAGE_SUCCES_MS
)
  {
    if (!pReactiveVar
     || typeof pReactiveVar.get !== 'function'
     || typeof pReactiveVar.set !== 'function') return null;

    let tTimer = null;
    const tDelay = Math.max (0, Number (pDelayMs) || 0);

    return Tracker.autorun ((pComputation) =>
      {
        if (tTimer)
          {
            clearTimeout (tTimer);
            tTimer = null;
          }

        pComputation.onInvalidate (() =>
          {
            if (!tTimer) return;
            clearTimeout (tTimer);
            tTimer = null;
          });

        const tMessage = pReactiveVar.get ();
        if (!message_est_succes (tMessage)) return;

        tTimer = setTimeout (() =>
          {
            if (pReactiveVar.get () === tMessage)
              pReactiveVar.set (null);
          }, tDelay);
      });
  }